import {axiosConfig} from '../api/axios-config.js'

// 機構
export const agency = {
  // 取得清單
  get: (id, token) => axiosConfig.get(`/api/agency/${id || ''}`, token),

  //  創建
  create: (data, token) => axiosConfig.post('/api/agency', data, token),

  // 更新
  update: (id, data, token) => axiosConfig.patch(`/api/agency/${id}`, data, token),

  // 更改狀態
  changeStatus: (id, data, token) => axiosConfig.put(`/api/agency/${id}`, data, token),

  // 刪除
  delete: (id, token) => axiosConfig.delete(`/api/agency/${id}`, token),

  getResidents: (id, token) => axiosConfig.get(`/api/agency/residents/${id}`, token),

  /**
   * 調整機構已使用額度
   * PUT /api/agency/{id}/quota/adjust
   */
  adjustQuota: (id, data, token) => {
    return axiosConfig.put(`/api/agency/${id}/quota/adjust`, data, token)
  },

  /**
   * 取得所有可用功能（用於新增機構）
   * GET /api/features
   */
  getAllFeatures: (token) => {
    return axiosConfig.get('/api/features', token)
  },

  /**
   * 取得機構功能設定
   * GET /api/agency/{id}/features
   */
  getFeatures: (id, token) => {
    return axiosConfig.get(`/api/agency/${id}/features`, token)
  },

  /**
   * 更新機構功能設定
   * PUT /api/agency/{id}/features
   */
  updateFeatures: (id, data, token) => {
    return axiosConfig.put(`/api/agency/${id}/features`, data, token)
  },

  impersonate: (id, token) => {
    return axiosConfig.post(`/api/agency/${id}/impersonate`, {}, token)
  },

  /**
   * 取得機構拋轉平台選項（value/label）
   * GET /api/agency/api-platforms
   */
  getApiPlatforms: (token) => {
    return axiosConfig.get('/api/agency/api-platforms', token)
  },

  /**
   * 取得機構 API 鑰匙清單
   * GET /api/agency/{id}/api-tokens
   */
  getApiTokens: (id, token) => {
    return axiosConfig.get(`/api/agency/${id}/api-tokens`, token)
  },

  /**
   * 產生機構 API 鑰匙（明文只在此次回傳）
   * POST /api/agency/{id}/api-tokens
   */
  createApiToken: (id, data, token) => {
    return axiosConfig.post(`/api/agency/${id}/api-tokens`, data, token)
  },

  /**
   * 撤銷機構 API 鑰匙
   * DELETE /api/agency/{id}/api-tokens/{tokenId}
   */
  revokeApiToken: (id, tokenId, token) => {
    return axiosConfig.delete(`/api/agency/${id}/api-tokens/${tokenId}`, token)
  },
}
